/* eslint-disable react/display-name */
import { forwardRef } from 'react';
import BEText from '@molecules/Text';
import { BEWeekdaysProps } from './BEWeekdaysProps';
import { StyledWeekdays, StyledDay } from './StyledWeekdays';

const BEWeekdays = forwardRef<HTMLDivElement, BEWeekdaysProps>(
  ({ weekdays, gap = 8 }) => {
    return (
      <StyledWeekdays>
        <BEText size="sm">{gap < 8 ? 'Availability' : 'Available on'}</BEText>
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((dayChar, dayIndex) => (
          <StyledDay
            key={dayIndex}
            isActive={weekdays[dayIndex] === 1}
            gap={gap}
          >
            {dayChar}
          </StyledDay>
        ))}
      </StyledWeekdays>
    );
  }
);

export default BEWeekdays;
